<template>
  <!-- 企業検診案件確認 -->
  <div id="KenshinRequestSearch">
    <div id="container">
      <kenshinNavi v-bind:pageid='"KenshinRequestSearch"'></kenshinNavi>
      <div class="kenshinLabelTitle lable">企業検診 案件確認</div>
      <div class="condition-area">
        <table class="conditionTable">
          <tr>
            <th width="120">受付番号</th><td><input type="text" id="receiptNumber" v-model="searchConditions.receiptNumber"/></td>
            <th>デモ</th><td><select id="type" v-model="searchConditions.demo"><option></option><option value="false">含まない</option><option value="true">デモのみ</option></select></td>
            <th>検査種類</th><td><select id="instrumentKind" v-model="searchConditions.inspectionKind"><option v-for="kind in inspectionKindList" :value="kind.value" :key="kind.value">{{ kind.label1 }}</option></select></td>
            <th>機種</th><td><select id="model" v-model="searchConditions.model"><option v-for="device in kenshinDeviceList" :value="device.value" :key="device.value">{{ device.label1 }}</option></select></td>
          </tr>
          <tr>
            <th>ステータス</th>
            <td><select id="status" v-model="searchConditions.status"><option v-for="status in statusList" :key="status.code" :value="status.code">{{status.name}}</option></select></td>
            <th>シリアル</th><td><input type="text" id="serialInput" v-model="searchConditions.serial" @keyup.enter="onKeyupEnter()"/></td>
            <th>依頼元</th><td><input type="text" id="client" v-model="searchConditions.client"/></td>
            <th>依頼元種別</th><td><select id="clientType" v-model="searchConditions.clientType"><option></option><option :value="role.role_corporation">企業</option><option :value="role.role_dealer">ディーラー</option><option :value="role.role_hospital">医療機関</option><option :value="role.role_accommodations">宿泊施設</option></select></td>
          </tr>
          <tr>
            <th>企業名</th><td><input type="text" id="corporation" v-model="searchConditions.companyName"/></td>
            <th>患者名</th><td><input type="text" id="corporation"  v-model="searchConditions.patientName"/></td>
            <th>受付日</th><td colspan="3"><input type="date" id="receptionDateStart" v-model="searchConditions.receptionDateStart"/> ～ <input type="date" id="receptionDateEnd" v-model="searchConditions.receptionDateEnd"/></td>
          </tr>
          <tr>
            <th>出荷日</th> <td colspan="3"><input type="date" id="shippingDateStart" v-model="searchConditions.shippingDateStart"/> ～ <input type="date" id="shippingDateEnd" v-model="searchConditions.shippingDateEnd"/></td>
            <th>機器返却日</th> <td colspan="3"><input type="date" id="returnDateStart" v-model="searchConditions.returnDateStart"/> ～ <input type="date" id="returnDateEnd" v-model="searchConditions.returnDateEnd"/></td>
          </tr>
          <tr>
            <th>判定依頼日</th> <td colspan="3"><input type="date" id="judgmentRequestDateStart" v-model="searchConditions.judgmentRequestDateStart"/> ～ <input type="date" id="judgmentRequestDateEnd" v-model="searchConditions.judgmentRequestDateEnd"/></td>
            <th>判定日</th> <td colspan="3"><input type="date" id="judgmentDateStart" v-model="searchConditions.judgmentDateStart"/> ～ <input type="date" id="judgmentDateEnd" v-model="searchConditions.judgmentDateEnd"/></td>
          </tr>
          <tr>
            <th>完了日</th> <td colspan="7"><input type="date" id="completionDateStart" v-model="searchConditions.completionDateStart"/> ～ <input type="date" id="completionDateEnd" v-model="searchConditions.completionDateEnd"/></td>
          </tr>
        </table>
        <div class="searchButton-area">
          <b-button class="is-primary" @click="doSearch" >検索</b-button>
        </div>
      </div>
      <!-- 検索結果 -->
      <div class="result-area" v-if="hasResult" >
        <div style="float:left">
          <b-button style="margin-right:10px;" class="clipboadCopyButton is-primary" @click="clipboardCopy('kenshinRequestSerchResultTable')">クリップボードにコピー</b-button>
          <b-button v-if="!isOpen" @click="isOpen=true" class="is-primary" icon-left="table-column-width" >列選択</b-button>
          <b-button v-if="isOpen" @click="isOpen=false" class="is-primary" icon-left="close-box-outline" >閉じる</b-button>
          <div v-if="isOpen" style="clear:both; height:0px;" >
            <div class="box selectColumn">
              <div style="height:30px;">
                <b-checkbox class="columnCheckBox" v-model="isAllChecked" @input="changeAllCheckBox" >全てチェック</b-checkbox>
                <a style="float:right;" @click="isOpen=false"><b-icon icon="close"/></a>
              </div>
              <b-checkbox class="columnCheckBox" v-model="columns.receiptNumber.checked" @input="changeCheckBox(columns.receiptNumber)" >受付番号</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.receptionDate.checked" @input="changeCheckBox(columns.receptionDate)" >受付日</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.instrumentKind.checked" @input="changeCheckBox(columns.instrumentKind)" >検査種類</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.demo.checked" @input="changeCheckBox(columns.demo)" >デモ</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.status.checked" @input="changeCheckBox(columns.status)" >ステータス</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.model.checked" @input="changeCheckBox(columns.model)" >機種</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.serial.checked" @input="changeCheckBox(columns.serial)" >シリアル</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.requester.checked" @input="changeCheckBox(columns.requester)" >依頼元</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.companyName.checked" @input="changeCheckBox(columns.companyName)" >企業名</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.office.checked" @input="changeCheckBox(columns.office)" >事業所名</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.shippingAddressZip.checked" @input="changeCheckBox(columns.shippingAddressZip)" >配送先郵便番号</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.shippingAddress.checked" @input="changeCheckBox(columns.shippingAddress)" >配送先</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.shippingPhone.checked" @input="changeCheckBox(columns.shippingPhone)" >配送先電話番号</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.shippingAddressTo.checked" @input="changeCheckBox(columns.shippingAddressTo)" >配送先宛名</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.resultSendAddressZip.checked" @input="changeCheckBox(columns.resultSendAddressZip)" >結果送付先郵便番号</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.resultSendAddress.checked" @input="changeCheckBox(columns.resultSendAddress)" >結果送付先</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.resultSendAddressTo.checked" @input="changeCheckBox(columns.resultSendAddressTo)" >結果送付先宛名</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.name.checked" @input="changeCheckBox(columns.name)" >名前</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.gender.checked" @input="changeCheckBox(columns.gender)" >性別</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.birthDate.checked" @input="changeCheckBox(columns.birthDate)" >生年月日</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.memo.checked" @input="changeCheckBox(columns.memo)" >備考</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.controlNumber.checked" @input="changeCheckBox(columns.controlNumber)" >検査ID</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.ahiOdi.checked" @input="changeCheckBox(columns.ahiOdi)" >AHI/ODI</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.shipDate.checked" @input="changeCheckBox(columns.shipDate)" >出荷日</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.machineReturnDate.checked" @input="changeCheckBox(columns.machineReturnDate)" >機器返却日</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.analysisRequestDate.checked" @input="changeCheckBox(columns.analysisRequestDate)" >判定依頼日</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.judgementName.checked" @input="changeCheckBox(columns.judgementName)" >判定医</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.analysisDate.checked" @input="changeCheckBox(columns.analysisDate)" >判定日</b-checkbox>
              <b-checkbox class="columnCheckBox" v-model="columns.completionDate.checked" @input="changeCheckBox(columns.completionDate)" >完了日</b-checkbox>
            </div>
          </div>
        </div>
        <b-table
          id="kenshinRequestSerchResultTable"
          :data="data"
          :paginated="true"
          per-page="50"
          pagination-position="both"
          default-sort="receiptNumber"
          aria-next-label="Next page"
          aria-previous-label="Previous page"
          aria-page-label="Page"
          aria-current-label="Current page"
        >
          <template slot-scope="props">
            <b-table-column :visible="columns.receiptNumber.checked" field="receiptNumber" label="受付番号" :width="columns.receiptNumber.width" centered sortable>
              <router-link :to="{name:'KenshinRequestSearchDetail',params:{item:props.row, searchConditions:searchConditions}}"><a>{{props.row.receiptNumber}}</a></router-link>
            </b-table-column>
            <b-table-column :visible="columns.receptionDate.checked" field="requestDate" label="受付日" :width="columns.receptionDate.width" centered sortable>{{props.row.requestDate}} </b-table-column>
            <b-table-column :visible="columns.instrumentKind.checked" field="inspectionKind" label="検査種類" :width="columns.instrumentKind.width" sortable>{{getChoiceName(props.row.inspectionKind,inspectionKindList)}}</b-table-column>
            <b-table-column :visible="columns.demo.checked" field="demo" label="デモ" :width="columns.demo.width" sortable><span v-if="props.row.demo">デモ</span> </b-table-column>
            <b-table-column :visible="columns.status.checked" field="status" label="ステータス" :width="columns.status.width" centered sortable>
              <span :class="getTagClass(props.row.status)"> {{getStatusName(props.row.status)}} </span>
            </b-table-column>
            <b-table-column :visible="columns.model.checked" field="model" label="機種" :width="columns.model.width" sortable>{{getChoiceName(props.row.model,kenshinDeviceList)}} </b-table-column>
            <b-table-column :visible="columns.serial.checked" field="serial" label="シリアル" :width="columns.serial.width" sortable>{{props.row.serial}} </b-table-column>
            <b-table-column :visible="columns.requester.checked" field="client" label="依頼元" :width="columns.requester.width" sortable>{{props.row.client}}<span v-if="props.row.proxyFlag" class="agent"/></b-table-column>
            <b-table-column :visible="columns.companyName.checked" field="companyName" label="企業名" :width="columns.companyName.width" sortable>{{props.row.companyName}} </b-table-column>
            <b-table-column :visible="columns.office.checked" field="enterpriseName" label="事業所名" :width="columns.office.width">{{props.row.enterpriseName}} </b-table-column>
            <b-table-column :visible="columns.shippingAddressZip.checked" field="deviceDeliveryPostcode" label="配送先郵便番号" :width="columns.shippingAddressZip.width" sortable>{{props.row.deviceDeliveryPostcode}} </b-table-column>
            <b-table-column :visible="columns.shippingAddress.checked" field="deviceDeliveryAddress" label="配送先" :width="columns.shippingAddress.width" sortable>{{props.row.deviceDeliveryAddress}} </b-table-column>
            <b-table-column :visible="columns.shippingPhone.checked" field="deviceDeliveryPhoneNumber" label="配送先電話番号" :width="columns.shippingPhone.width" sortable>{{props.row.deviceDeliveryPhoneNumber}} </b-table-column>
            <b-table-column :visible="columns.shippingAddressTo.checked" field="deviceDeliveryName" label="配送先宛名" :width="columns.shippingAddressTo.width" sortable>{{props.row.deviceDeliveryName}} </b-table-column>
            <b-table-column :visible="columns.resultSendAddressZip.checked" filed="resultDeliveryPostcode" label="結果送付先郵便番号" :width="columns.resultSendAddressZip.width" sortable>{{props.row.resultDeliveryPostcode}} </b-table-column>
            <b-table-column :visible="columns.resultSendAddress.checked" field="resultDeliveryAddress" label="結果送付先" :width="columns.resultSendAddress.width" sortable>{{props.row.resultDeliveryAddress}} </b-table-column>
            <b-table-column :visible="columns.resultSendAddressTo.checked" field="resultDeliveryName" label="結果送付先宛名" :width="columns.resultSendAddressTo.width" sortable>{{props.row.resultDeliveryName}} </b-table-column>
            <b-table-column :visible="columns.name.checked" field="name" label="名前" :width="columns.name.width" sortable>{{props.row.name}} </b-table-column>
            <b-table-column :visible="columns.gender.checked" field="gender" label="性別" :width="columns.gender.width" sortable>{{props.row.gender}} </b-table-column>
            <b-table-column :visible="columns.birthDate.checked" field="birthday" label="生年月日" :width="columns.birthDate.width" sortable>{{props.row.birthday}} </b-table-column>
            <b-table-column :visible="columns.memo.checked" field="biko" label="備考" :width="columns.memo.width" sortable>{{props.row.biko}} </b-table-column>
            <b-table-column :visible="columns.controlNumber.checked" field="examinationId" label="検査ID" :width="columns.controlNumber.width" sortable>{{props.row.examinationId}} </b-table-column>
            <b-table-column :visible="columns.ahiOdi.checked" field="ahiOdi" label="AHI/ODI" :width="columns.ahiOdi.width" centered >{{props.row.ahiOdi}} </b-table-column>
            <b-table-column :visible="columns.shipDate.checked" field="shippingDate" label="出荷日" :width="columns.shipDate.width" centered sortable>{{props.row.shippingDate}} </b-table-column>
            <b-table-column :visible="columns.machineReturnDate.checked" field="returnDate" label="機器返却日" :width="columns.machineReturnDate.width" centered sortable>{{props.row.returnDate}} </b-table-column>
            <b-table-column :visible="columns.analysisRequestDate.checked" field="JudgmentRequestDate" label="判定依頼日" :width="columns.analysisRequestDate.width" centered sortable>{{props.row.JudgmentRequestDate}} </b-table-column>
            <b-table-column :visible="columns.judgementName.checked" field="judgementName" label="判定医" :width="columns.judgementName.width" centered sortable>{{props.row.judgementName}} </b-table-column>
            <b-table-column :visible="columns.analysisDate.checked" field="judgmentDate" label="判定日" :width="columns.analysisDate.width" centered sortable>{{props.row.judgmentDate}} </b-table-column>
            <b-table-column :visible="columns.completionDate.checked" field="completionDate" label="完了日" :width="columns.completionDate.width" centered sortable>{{props.row.completionDate}} </b-table-column>
          </template>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
import naviBar from "@/components/mock/philips/kenshin/KenshinNaviBar";
import {choicesType} from "@/components/mock/base/const.js";
import {role} from "@/components/mock/base/const.js";

export default {
  name: "KenshinRequestSearch",
  methods: {
    onKeyupEnter: function(){
      //シリアルを取得
      let serialItems = this.searchConditions.serial.split('/');
      if(serialItems.length == 2){
        //　"/"が含まれていたらそれ以降の文字に変更する
        this.searchConditions.serial = serialItems[1]
      }
    },
    doSearch: function() {
      var isSearchParam = false
      var keys = Object.keys(this.searchConditions)
      for(var i=0; i < keys.length; i++){
        if(this.searchConditions[keys[i]]){
          isSearchParam = true
          break;
        }
      }
      if(!isSearchParam){
        // 検索条件が１つも設定されていない場合
        this.showErrorMessage("検索条件が入力されていません。")
        return;
      }
      this.data = []
      this.hasResult = false;
      var excuteApi = this.getKenshinRequestListPOST;
      var successCallBack = this.getKenshinRequestListPOSTSuccess;
      var errorCallBack = this.getKenshinRequestListPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getKenshinRequestListPOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.searchConditions));
      if(obj.status && obj.status.length!=0){
        if(obj.status == "[100]"){
          obj.dataExtractionFlag = "true"
          obj.status = [5]
        }else if (obj.status == "[5]"){
          obj.dataExtractionFlag = "false"
          obj.status = [5]
        }else{
          obj.status = JSON.parse(obj.status)
        }
      }else{
        obj.status = []
      }
      if(!obj.clientType){
        delete obj.clientType
      }
      return client.apis.internalKenshin.getKenshinRequestListPOST({
        body:obj
      });
    },
    getKenshinRequestListPOSTSuccess: function(result) {
      // 検索結果取得
      this.data = result.obj
      if(this.data.length > 0){
        this.hasResult = true;
      }
    },
    getKenshinRequestListPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    getStatusName: function(code) {
      var target = this.statusList.find(val => val.code && val.code.includes(code))
      if(target){
        return target.name
      }
      return ""
    },
    getChoiceName: function(val,list) {
      var target = list.find(item => item.value == val)
      if(target){
        return target.label1
      }
      return ""
    },
    changeCheckBox: function(checkboxModel) {
      var width = checkboxModel.width;
      var tableElement = this.getTableElement();
      var newWidth = 0;
      if (checkboxModel.checked) {
        newWidth = tableElement.clientWidth + width;
      } else {
        newWidth = tableElement.clientWidth - width;
      }
      this.chengeTableWidth(newWidth);
    },
    getTableElement: function(){
      var parentElement = document.getElementById(
        "kenshinRequestSerchResultTable"
      );
      return parentElement.getElementsByTagName("table")[0];      
    },
    changeAllCheckBox: function() {
      if(this.isAllChecked){
        this.chengeTableWidth(this.tableWidth);
      } else {
        this.chengeTableWidth(0);
      }
      Object.values(this.columns).map(clumn => clumn.checked = this.isAllChecked)
    },
    chengeTableWidth: function(width){
      var tableElement = this.getTableElement();
      tableElement.style.width = width + "px";
    },
    clipboardCopy: function(elementId) {
      var btable = document.getElementById(elementId);
      var tableWrapper = btable.getElementsByClassName("table-wrapper")[0];
      var table = tableWrapper.getElementsByTagName("table")[0];
      var tbody = table.getElementsByTagName("tbody")[0];
      navigator.clipboard
        .writeText(tbody.innerText)
        .then(() => {
          this.showMessage("クリップボードにコピーしました。");
        })
        .catch(err => {
          this.showMessage("コピーに失敗しました");
          console.log(err);
        });
    },
  },
  data() {
    var columns = {
        receiptNumber: { checked: true, width: 120 },
        receptionDate: { checked: true, width: 110 },
        demo: { checked: true, width: 50 },
        instrumentKind: { checked: true, width: 270 },
        status: { checked: true, width: 200 },
        model: { checked: true, width: 200 },
        serial: { checked: true, width: 150 },
        requester: { checked: true, width: 250 },
        companyName: { checked: true, width: 250 },
        office: { checked: true, width: 250 },
        shippingAddressZip: { checked: true, width: 100 },
        shippingAddress: { checked: true, width: 400 },
        shippingPhone: { checked: true, width: 200 },
        shippingAddressTo: { checked: true, width: 250 },
        resultSendAddressZip: { checked: true, width: 100 },
        resultSendAddress: { checked: true, width: 400 },
        resultSendAddressTo: { checked: true, width: 250 },
        name: { checked: true, width: 150 },
        gender: { checked: true, width: 60 },
        birthDate: { checked: true, width: 100 },
        memo: { checked: true, width: 400 },
        controlNumber: { checked: true, width: 140 },
        ahiOdi: { checked: true, width: 80 },
        shipDate: { checked: true, width: 110 },
        machineReturnDate: { checked: true, width: 110 },
        analysisRequestDate: { checked: true, width: 110 },
        judgementName: { checked: true, width: 200 },
        analysisDate: { checked: true, width: 110 },
        completionDate: { checked: true, width: 110 }
      }
    var tableWidth = 0;
    Object.values(columns).map(clumn => {
      if(clumn.checked) tableWidth += clumn.width
    })
    var statusList =[
      {name:"未受付", code:"[1]"}
     ,{name:"企業検診G受付済", code:"[11]"}
     ,{name:"川越受付済", code:"[2]"}
     ,{name:"出荷準備中", code:"[3]"}
     ,{name:"出荷済み", code:"[4]"}
     ,{name:"機器受領中", code:"[5]"}
     ,{name:"再検査調整中", code:"[16]"}
     ,{name:"データ抽出済", code:"[100]"}
     ,{name:"判定依頼中", code:"[12]"}
     ,{name:"判定結果作成中", code:"[9]"}
     ,{name:"完了", code:"[13,14,15,18]"}
     ,{name:"キャンセル", code:"[17]"}
    ]
    statusList.unshift({})
    var takeOverSearchParams = this.$route.params["searchConditions"];
    var inspectionKindList = this.getChoiceList(choicesType.kenshinKind, false);
    inspectionKindList.unshift({})
    var kenshinDeviceList = this.getChoiceList(choicesType.kenshinDevice, false);
    kenshinDeviceList.unshift({})
    return {
      takeOverSearchParams,
      inspectionKindList,
      kenshinDeviceList,
      role: role,
      statusList,
      searchConditions:{
        receiptNumber:"",
        demo:"",
        inspectionKind:"",
        model:"",
        status:"",
        serial:"",
        client:"",
        clientType:"",
        companyName:"",
        patientName:"",
        // 受付日
        receptionDateStart:"",
        receptionDateEnd:"",
        // 出荷日
        shippingDateStart:"",
        shippingDateEnd:"",
        // 機器返却日
        returnDateStart:"",
        returnDateEnd:"",
        // 判定依頼日
        judgmentRequestDateStart:"",
        judgmentRequestDateEnd:"",
        // 判定日
        judgmentDateStart:"",
        judgmentDateEnd:"",
        // 完了日
        completionDateStart:"",
        completionDateEnd:""
      },
      data: [],
      hasResult: false,
      isOpen: false,
      isAllChecked: true,
      columns: columns,
      tableWidth : tableWidth
    };
  },
  async mounted() {
    // 選択肢マスタ取得
    if(this.takeOverSearchParams){
      this.searchConditions = this.takeOverSearchParams
      this.doSearch()
    }
  },
  filters: {},
  components: {
    kenshinNavi: naviBar
  }
};
</script>
<style lang="scss" scoped>
a {
  text-decoration: underline;
}
input {
  width: 200px;
}
.tag {
  width: 100px;
}
.selectColumn {
  width: 800px;
  position: absolute;
  background-color: white;
  z-index: 25;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/kenshin/KenshinRequestSearch.vue